import Timer from 'components/Timer';
import InfoElement from '../InfoElement';
import { Vehicle } from '../../../types/vehicle';
import { getHighestBid, getVehicleTimer } from '../../../utils/vehicle';
import { useMemo } from 'react';
import { BuyNowButton } from '../BuyNowButton';
import { MOBILE_BREAKPOINT } from 'constants';
import { useWindowSize } from 'usehooks-ts';
import { useSelector } from 'react-redux';
import { useTimerConfig } from 'hooks';

type Props = {
  vehicle: Vehicle;
  isExpanded: boolean;
  buyNowRef?: React.RefObject<HTMLDivElement>;
};

export const DealInfo = ({ vehicle, isExpanded, buyNowRef }: Props) => {
  const { timer: vehicleTimer } = useTimerConfig(vehicle);
  const highestBid = getHighestBid(vehicle);
  const user = useSelector((state: any) => state.user.user);

  const isAlternativeAuction = vehicle.auction.type !== 'autoaxess';

  const { title, amount, showPrice } = useMemo(() => {
    if (isAlternativeAuction) {
      return {
        title: vehicle.top_alternative_bid_offer?.amount ? 'Current Offer' : 'Starting Offer',
        amount: vehicle.top_alternative_bid_offer?.amount || vehicle.starting_bid || 100,
        showPrice: true
      };
    }

    const bidComponentTitle = highestBid?.amount ? 'Current bid' : 'Starting/Min Bid';
    const bidComponentAmount = highestBid?.amount || vehicle?.starting_bid || 100;

    return {
      title: bidComponentTitle,
      amount: bidComponentAmount,
      showPrice: true
    };
  }, [vehicle.auction.type, highestBid, vehicle?.starting_bid]);

  const buyNowVisible =
    vehicle.status === 'active' &&
    user?.role === 'buyer' &&
    !vehicle.in_battle &&
    vehicle.active_alternative_offer &&
    isAlternativeAuction &&
    !isExpanded;

  const { width = 0 } = useWindowSize();
  const isMobile = width <= MOBILE_BREAKPOINT;

  return (
    <>
      {showPrice && <InfoElement isGridView bid type="currency" item={title} value={amount} />}
      {!buyNowVisible && !isMobile && <div style={{ height: 12 }} />}
      {!!vehicleTimer && (
        <InfoElement isGridView type="time" item="Time left" value={<Timer toDate={vehicleTimer} />} />
      )}
      {buyNowVisible && <BuyNowButton containerRef={buyNowRef} vehicle={vehicle} />}
    </>
  );
};
